import { sql } from "drizzle-orm";

import { bulkInsert } from "@/db/bulkInsert";
import { db } from "@/db/db";
import { tag } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";
import { logQuery } from "@/models/logQuery";

type TagRecord = { id: string; label: string; enabled: boolean; multiValue: boolean; values?: string[] };

export async function bulkUpsertTag(records: TagRecord[]) {
  if (records.length === 0) return;
  const slim = records.map(({ id, label, enabled, multiValue }) => ({ id, label, enabled, multiValue }));
  const deduped = deduplicateByKeyValue(slim, (item) => item.id);
  await bulkInsert(tag, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [tag.id],
      set: {
        label: sql`"excluded"."label"`,
        enabled: sql`"excluded"."enabled"`,
        multiValue: sql`"excluded"."multiValue"`,
      },
    },
  });
  emitTableUpdates(["tag"]);
}

export async function replaceAllTags(records: TagRecord[]) {
  const slim = records.map(({ id, label, enabled, multiValue }) => ({ id, label, enabled, multiValue }));
  const deduped = deduplicateByKeyValue(slim, (item) => item.id);

  await db.delete(tag);

  if (deduped.length > 0) {
    await bulkInsert(tag, deduped, {
      onConflict: { type: "doNothing" },
    });
  }

  emitTableUpdates(["tag"]);
}

export function allTagsQuery() {
  const query = db.select({ id: tag.id, label: tag.label, enabled: tag.enabled, multiValue: tag.multiValue }).from(tag);
  logQuery("All Tags", query);
  return query;
}
